import { defaultTheme as theme } from '@auth0/quantum-product';
import i18next from 'i18next';
export var getTypography = function () {
    var language = i18next.language;
    var isJapanese = language === 'ja-jp';
    var adjustFontSize = function (size) {
        if (size <= 14)
            return size;
        var adjustedSize = isJapanese ? size * 0.85 : size;
        return adjustedSize < 14 ? 14 : adjustedSize;
    };
    var createTypographyStyle = function (fontSize, lineHeight, letterSpacing) { return ({
        fontSize: theme.typography.pxToRem(adjustFontSize(fontSize)),
        letterSpacing: letterSpacing,
        fontFamily: isJapanese ? 'Noto Sans JP, Roboto, Helvetica, Arial, sans-serif' : theme.typography.fontFamily,
    }); };
    return {
        fontFamily: isJapanese ? 'Noto Sans JP, Roboto, Helvetica, Arial, sans-serif' : theme.typography.fontFamily,
        h1: createTypographyStyle(40, 44, -0.8),
        h2: createTypographyStyle(32, 40, -0.5),
        h3: createTypographyStyle(28, 36, -0.3),
        h4: createTypographyStyle(24, 32, -0.2),
        h5: createTypographyStyle(20, 28, -0.1),
        h6: createTypographyStyle(18, 24, -0.1),
        body1: createTypographyStyle(16, 1.5, 0),
        body2: createTypographyStyle(14, 1.57143, 0),
        subtitle1: createTypographyStyle(16, 1.5, 0),
        subtitle2: createTypographyStyle(14, 1.57143, 0),
        label: createTypographyStyle(12, 1.33333, 0),
        button: createTypographyStyle(14, 1.57143, 0),
        caption: createTypographyStyle(12, 1.33333, 0),
        overline: createTypographyStyle(10, 2, 1.5),
        input: createTypographyStyle(16, 1.5, 0),
        code: {
            fontFamily: isJapanese
                ? 'Noto Sans JP, Roboto Mono, Menlo, Monaco, Consolas, Courier New, monospace'
                : 'Roboto Mono, Menlo, Monaco, Consolas, Courier New, monospace',
            '-webkit-font-smoothing': 'subpixel-antialiased',
        },
    };
};
